export default {
    menuState: {
        '0': '正常',
        '1': '停用'
    },
    menuType: {
        'M': '目录',
        'C': '菜单',
        'F': '按钮'
    },
    // 菜单显示状态
    visibleState: {
      '0': '显示',
      '1': '隐藏'  
    }
}